"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MatrixRoom = exports.MatrixRoomStatus = void 0;
const events_1 = require("../utils/events");
const MatrixMessage_1 = require("./MatrixMessage");
var MatrixRoomStatus;
(function (MatrixRoomStatus) {
    MatrixRoomStatus[MatrixRoomStatus["UNKNOWN"] = 0] = "UNKNOWN";
    MatrixRoomStatus[MatrixRoomStatus["JOINED"] = 1] = "JOINED";
    MatrixRoomStatus[MatrixRoomStatus["INVITED"] = 2] = "INVITED";
    MatrixRoomStatus[MatrixRoomStatus["LEFT"] = 3] = "LEFT";
})(MatrixRoomStatus = exports.MatrixRoomStatus || (exports.MatrixRoomStatus = {}));
class MatrixRoom {
    constructor(id, status = MatrixRoomStatus.UNKNOWN, members = [], messages = []) {
        this.id = id;
        this.status = status;
        this.members = members;
        this.messages = messages;
    }
    static fromSync(roomSync) {
        function create(rooms, creator) {
            return Object.entries(rooms).map(([id, room]) => creator(id, room));
        }
        return [
            ...create(roomSync.join, MatrixRoom.fromJoined),
            ...create(roomSync.invite, MatrixRoom.fromInvited),
            ...create(roomSync.leave, MatrixRoom.fromLeft)
        ];
    }
    static from(roomOrId, status) {
        return roomOrId instanceof MatrixRoom
            ? status
                ? new MatrixRoom(roomOrId.id, status, roomOrId.members, roomOrId.messages)
                : roomOrId
            : new MatrixRoom(roomOrId, status || MatrixRoomStatus.UNKNOWN);
    }
    static fromJoined(id, joined) {
        const events = [...joined.state.events, ...joined.timeline.events];
        const members = MatrixRoom.getMembersFromEvents(events);
        const messages = MatrixRoom.getMessagesFromEvents(events);
        return new MatrixRoom(id, MatrixRoomStatus.JOINED, members, messages);
    }
    static fromInvited(id, invited) {
        const members = MatrixRoom.getMembersFromEvents(invited.invite_state.events);
        return new MatrixRoom(id, MatrixRoomStatus.INVITED, members);
    }
    static fromLeft(id, left) {
        const events = [...left.state.events, ...left.timeline.events];
        const members = MatrixRoom.getMembersFromEvents(events);
        const messages = MatrixRoom.getMessagesFromEvents(events);
        return new MatrixRoom(id, MatrixRoomStatus.LEFT, members, messages);
    }
    static getMembersFromEvents(events) {
        return events
            .filter((event) => events_1.isCreateEvent(event) || events_1.isJoinEvent(event))
            .map((event) => event.sender)
            .filter((member, index, array) => array.indexOf(member) === index);
    }
    static getMessagesFromEvents(events) {
        return events
            .filter(events_1.isMessageEvent)
            .map((event) => MatrixMessage_1.MatrixMessage.from(event))
            .filter((message) => !!message);
    }
}
exports.MatrixRoom = MatrixRoom;
//# sourceMappingURL=MatrixRoom.js.map